module.exports = __webpack_public_path__ + "media/application/images/logo-royston-20bcdbf673f01947db492834aeb9e488.svg";